import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from 'primereact/checkbox';
import Translate from '../../common/functions/translate';
import { Role } from '../../common/enums';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import AuthService from "../../services/authService";

const UserList = (props) => {

  let authService = new AuthService();

  return (
    <DataTable
      value={props.users}
      responsive
      paginator={true}
      lazy={true}
      rowsPerPageOptions={[10, 20, 50, 100]}
      rows={props.rows}
      totalRecords={props.totalRecords}
      onPage={(event) => props.onPageClick(event)}
      first={props.first}
      dataKey='userId'
      onRowClick={(e) => props.editClick(e.data.userId)}
      selectionMode='single'
    //loading={props.isLoading}	
    >
      <Column field="name" header={Translate("Name")} />
      <Column field="email" header={Translate("Email")} />
      <Column
        field="role"
        header={Translate("Role")}
        body={(rowData, column) =>
          <>
            {rowData.roleId === Role.Administrator ? Translate('Administrator') : ''}
            {rowData.roleId === Role.ProductManager ? Translate('ProductManager') : ''}
            {rowData.roleId === Role.RegionalManager ? Translate('RegionalManager') : ''}
            {rowData.roleId === Role.Trader ? Translate('Trader') : ''}
          </>
        } />
      <Column
        field="region"
        header={Translate("Region")}
        body={(rowData, column) =>
          <>
            {rowData.region ? rowData.region : ""}
          </>
        }
      />
      <Column
        field="code"
        header={Translate("Code")}
        body={(rowData, column) =>
          <>
            {rowData.code ? rowData.code : ""}
          </>
        }
      />
      <Column
        field={"createdOn"}
        header={Translate("Registered")}
        body={(rowData, column) =>
          <div>
            {HelperFunctions.fomatDatesStringWithLang(new Date(rowData.createdOn))}
          </div>
        }
      />
      <Column
        style={{ width: "8em" }}
        field="isActive"
        className='data-table-cell'
        header={Translate("Active")}
        body={(rowData, column) =>
          <>
            <Checkbox
              readOnly={true}
              disabled={true}
              checked={rowData.isActive}
              onChange={() => null}
            />
          </>
        }
      />
      <Column
        header={Translate("Actions")}
        style={{ width: "8em", textAlign: "left" }}
        className='data-table-cell'
        body={(rowData, column) =>
          <>
            <Button
              type="button"
              icon="pi pi-pencil"
              className="p-button-warning"
              tooltip={Translate("Edit")}
              tooltipOptions={{ position: 'top' }}
              style={{ marginRight: ".5em" }}
              onClick={() => props.editClick(rowData.userId)}
            />
            {rowData.email !== "admin@admin.com" && rowData.email !== authService.getLoginName() ?
              <Button
                type="button"
                icon="pi pi-trash"
                className="p-button-danger"
                tooltip={Translate("Delete")}
                tooltipOptions={{ position: 'top' }}
                onClick={(e) => props.deleteClick(rowData.userId, e)}
              /> : null}
          </>
        }
      />
    </DataTable>
  )
}

export default UserList;
